// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"322":"58ea7110","2004":"271f7c41","6212":"d9435371"}[chunkId] + ".chunk.css";
};